import * as React from 'react';
import { useEditorContext } from '../editor_context';
import { CodeButton, LinkButton, BoldButton, ItalicButton, UnderlineButton } from './buttons';
import { MenuSeparator } from './MenuSeparator';

const markToButtons = {
   bold: [<BoldButton key="bold" />],
   italic: [<ItalicButton key="italic" />],
   code: [<CodeButton key="code" />],
   link: [<LinkButton key="link" />],
   underline: [<UnderlineButton key="underline" />],
};

type Mark = keyof typeof markToButtons;

interface MarkMenuItemProps {
   mark: Mark;
}

const MarkMenuItem = (props: MarkMenuItemProps) => {
   return <>{markToButtons[props.mark]}</>;
};

interface MarkMenuProps {
   preSeparator?: boolean;
   postSeparator?: boolean;
}

export const MarkMenu = (props: MarkMenuProps) => {
   const { editor } = useEditorContext();

   const buttons = (Object.keys(markToButtons) as Mark[])
      .filter(mark => mark in editor.schema.marks)
      .map(mark => <MarkMenuItem mark={mark} key={mark} />);

   if (!buttons.length) {
      return null;
   }

   return (
      <>
         {props.preSeparator ? <MenuSeparator /> : null}
         {buttons}
         {props.postSeparator ? <MenuSeparator /> : null}
      </>
   );
};
